exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-layout[data-v-efb8b9dc] {\n  height: 100%;\n}", ""]);

// exports
